import React, { createContext, useState } from 'react';
import { notification } from 'antd';

export const NotifContext = createContext();

const NotifContextProvider = (props) => {
    const [showNotif, setShowNotif] = useState(false);
    const hide = () => {
        setShowNotif(false);
    };

    const show = (type, title, description, placement) => {
        setShowNotif(true);
        notification[type]({
            message: title,
            description,
            placement,
        });
    };

    return (
        <NotifContext.Provider
            value={{
                showNotif,
                setShowNotif,
                show,
                hide,
            }}
        >
            {props.children}
        </NotifContext.Provider>
    );
};

export default NotifContextProvider;
